
import React from 'react'
import {
  Box as BaseBox,
  HBox as BaseHBox,
  VBox as BaseVBox
} from 'box.js'

/**
 * Scale base.
 */

const scale = 4;

/**
 * Properties to scale.
 */

const scaleProperties = [
  'padding',
  'paddingX',
  'paddingY',
  'paddingTop',
  'paddingRight',
  'paddingBottom',
  'paddingLeft',
  'margin',
  'marginX',
  'marginY',
  'marginTop',
  'marginRight',
  'marginBottom',
  'marginLeft',
]

/**
 * Export Box as the default.
 */

export default Box

/**
 * Box component.
 */

export function Box({ children, ...props }) {
  const [className, rest] = classname(props)
  return <BaseBox className={className} {...rest}>
    {children}
  </BaseBox>
}

/**
 * HBox component.
 */

export function HBox({ children, ...props }) {
  const [className, rest] = classname(props)
  return <BaseHBox className={className} {...rest}>
    {children}
  </BaseHBox>
}

/**
 * VBox component.
 */

export function VBox({ children, ...props }) {
  const [className, rest] = classname(props)
  return <BaseVBox className={className} {...rest}>
    {children}
  </BaseVBox>
}

/**
 * classname helper.
 */

function classname(props) {
  const {
    className,
    classes,

    scrollbars,
    
    required,
    disabled,
    pending,
    
    fontSize,
    fontWeight,
    truncate,
    muted,

    background,
    backgroundHover,
    
    borderRadius,
    border,
    borderTop,
    borderRight,
    borderBottom,
    borderLeft,

    inset,
    shadow,
    shadowTop,
    shadowRight,
    shadowBottom,
    shadowLeft,

    animate,

    ...rest
  } = props

  let c = []

  // class
  if (className) c.push(className)
  if (classes) c = c.concat(classes)

  // animate
  if (animate) c.push(`animate-${animate}`)

  // shadow
  if (shadow) c.push(`shadow-${shadow}`)
  if (inset) c.push(`inset`)
  if (shadowTop) c.push(`shadow-top`)
  if (shadowRight) c.push(`shadow-right`)
  if (shadowBottom) c.push(`shadow-bottom`)
  if (shadowLeft) c.push(`shadow-left`)

  // text
  if (fontSize != null) c.push(`text-${fontSize}`)
  if (fontWeight) c.push(`weight-${fontWeight}`)
  if (truncate) c.push(`truncate`)
  if (muted) c.push(`text-muted`)

  // background
  if (background != null) c.push(`bg-${background}`)
  if (backgroundHover != null) c.push(`hover-bg-${backgroundHover}`)

  // states
  if (required) c.push(`required`)
  if (disabled) c.push(`disabled`)
  if (pending) c.push(`pending`)

  // scrollbars
  if (scrollbars) c.push(`scrollbars-${scrollbars}`)

  // border
  if (borderRadius) c.push(`radius-${borderRadius}`)
  if (border) c.push(`border`)
  if (borderTop) c.push(`border-top`)
  if (borderRight) c.push(`border-right`)
  if (borderBottom) c.push(`border-bottom`)
  if (borderLeft) c.push(`border-left`)
  
  // scale
  for (let i = 0; i < scaleProperties.length; i++) {
    const k = scaleProperties[i]
    const v = rest[k]
    if (v && typeof v == 'number') {
      rest[k] = v * scale
    }
  }

  return [
    c.join(' '),
    { 
      required,
      disabled,
      ...rest
    }
  ]
}
